// extracted by mini-css-extract-plugin
export default {"wrap":"Breadcrumbs_wrap__h3HZa","list":"Breadcrumbs_list__vZQoy","item":"Breadcrumbs_item__ahSWm"};